import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { FilterListValue, FilterListValueApi } from '@core/interface/global-search/filter-list.interface';
@Injectable({ providedIn: 'root' })

export class filterListResolver {
  constructor(private apiService: ApiServiceService,
    private context: ContextFactory,
    private loader: LoaderFactory) { }

  resolve(route: ActivatedRouteSnapshot) {
    this.loader.openLoader('open-search');

    let id = 'regular';
    if (this.context.settings?.defaultProduct === 'icam') {
      id = 'icam';
    } else if (this.context.settings?.defaultProduct === 'vithas') {
      id = 'vithas';
    }

    return this.apiService.get('search/filter-set/', id)
      .then((data: {[key: string]: [FilterListValueApi[]]}) => {
        this.loader.closeLoader(['open-search', 'front-login-login']);
        return this.mapData(data);
      });
  }

  mapData(data: {[key: string]: [FilterListValueApi[]]}): {[key: string]: FilterListValue[]} {
    const result: {[key: string]: FilterListValue[]} = {};
    for (let [filterName, filterList] of Object.entries(data)) {
      const listValues: FilterListValue[] = [];
      for (const item of filterList[0]) {
        let listValue: FilterListValue = {listValueId: item.Id, text: item.Text ?? item.Id};
        if ('IsDeleted' in item) {
          listValue.isDeleted = item.IsDeleted;
        }
        // FSubfolders
        if ('ParentId' in item) {
          listValue.parentFolderId = item.ParentId;
        }
        listValues.push(listValue);
      }
      result[filterName] = listValues;
    }
    return result;
  }
}
